// src/mocks/transactionsMockData.js

// Generate unique transactions for specific dates
const generateTransactionsByDate = (date, count, startId) => {
  // ✅ Changed: COMPLETED or REJECTED (no FAILED)
  const statuses = ["COMPLETED", "COMPLETED", "COMPLETED", "COMPLETED", "REJECTED"];
  const transactions = [];

  for (let i = 0; i < count; i++) {
    const amount = Math.floor(Math.random() * 500) + 50;
    const platformFee = 0.02;
    const transactionFee = 0.5;
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    
    // ✅ Generate penalty for REJECTED transactions (10-20 Rs)
    const rejectionPenalty = status === "REJECTED" ? (10 + Math.floor(Math.random() * 11)) : 0;
    
    // ✅ Calculate net earning (subtract penalty for rejected)
    const baseEarning = amount - platformFee - transactionFee;
    const netEarning = status === "REJECTED" ? 0 : baseEarning; // Vendor gets 0 for rejected
    
    const hour = Math.floor(Math.random() * 12) + 9;
    const minute = Math.floor(Math.random() * 60);
    const timestamp = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    
    transactions.push({
      id: startId + i,
      transactionId: `TXN${String(startId + i).padStart(6, "0")}`,
      userId: `USR${String(Math.floor(Math.random() * 500) + 1).padStart(4, "0")}`,
      amount: parseFloat(amount.toFixed(2)),
      platformFee: platformFee,
      transactionFee: transactionFee,
      rejectionPenalty: rejectionPenalty, // ✅ New field
      netEarning: parseFloat(netEarning.toFixed(2)),
      status: status,
      timestamp,
      date: date,
    });
  }
  
  return transactions.sort((a, b) => a.timestamp.localeCompare(b.timestamp));
};

// All daily summaries from all weeks with transaction counts
const dailySummaryDates = [
  // Week 1: Oct 30 - Nov 05, 2024
  { date: "Nov 05, 2024", transactionCount: 2 },
  { date: "Nov 04, 2024", transactionCount: 3 },
  { date: "Nov 03, 2024", transactionCount: 4 },
  { date: "Nov 02, 2024", transactionCount: 3 },
  { date: "Nov 01, 2024", transactionCount: 2 },
  { date: "Oct 31, 2024", transactionCount: 4 },
  { date: "Oct 30, 2024", transactionCount: 3 },
  
  // Week 2: Oct 23 - Oct 29, 2024
  { date: "Oct 29, 2024", transactionCount: 3 },
  { date: "Oct 28, 2024", transactionCount: 2 },
  { date: "Oct 27, 2024", transactionCount: 4 },
  { date: "Oct 26, 2024", transactionCount: 3 },
  { date: "Oct 25, 2024", transactionCount: 2 },
  { date: "Oct 24, 2024", transactionCount: 3 },
  { date: "Oct 23, 2024", transactionCount: 1 },
  
  // Week 3: Oct 16 - Oct 22, 2023
  { date: "Oct 22, 2023", transactionCount: 2 },
  { date: "Oct 21, 2023", transactionCount: 3 },
  { date: "Oct 20, 2023", transactionCount: 3 },
  { date: "Oct 19, 2023", transactionCount: 2 },
  { date: "Oct 18, 2023", transactionCount: 2 },
  { date: "Oct 17, 2023", transactionCount: 3 },
  { date: "Oct 16, 2023", transactionCount: 1 },
  
  // Week 4: Oct 09 - Oct 15, 2023
  { date: "Oct 15, 2023", transactionCount: 4 },
  { date: "Oct 14, 2023", transactionCount: 3 },
  { date: "Oct 13, 2023", transactionCount: 2 },
  { date: "Oct 12, 2023", transactionCount: 3 },
  { date: "Oct 11, 2023", transactionCount: 3 },
  { date: "Oct 10, 2023", transactionCount: 3 },
  { date: "Oct 09, 2023", transactionCount: 2 },
  
  // Week 5: Oct 02 - Oct 08, 2023
  { date: "Oct 08, 2023", transactionCount: 3 },
  { date: "Oct 07, 2023", transactionCount: 2 },
  { date: "Oct 06, 2023", transactionCount: 3 },
  { date: "Oct 05, 2023", transactionCount: 2 },
  { date: "Oct 04, 2023", transactionCount: 3 },
  { date: "Oct 03, 2023", transactionCount: 2 },
  { date: "Oct 02, 2023", transactionCount: 2 },
  
  // Week 6: Sep 25 - Oct 01, 2023
  { date: "Oct 01, 2023", transactionCount: 2 },
  { date: "Sep 30, 2023", transactionCount: 3 },
  { date: "Sep 29, 2023", transactionCount: 2 },
  { date: "Sep 28, 2023", transactionCount: 3 },
  { date: "Sep 27, 2023", transactionCount: 2 },
  { date: "Sep 26, 2023", transactionCount: 2 },
  { date: "Sep 25, 2023", transactionCount: 1 },
  
  // Week 7: Sep 18 - Sep 24, 2023
  { date: "Sep 24, 2023", transactionCount: 2 },
  { date: "Sep 23, 2023", transactionCount: 3 },
  { date: "Sep 22, 2023", transactionCount: 2 },
  { date: "Sep 21, 2023", transactionCount: 3 },
  { date: "Sep 20, 2023", transactionCount: 2 },
  { date: "Sep 19, 2023", transactionCount: 2 },
  { date: "Sep 18, 2023", transactionCount: 1 },
  
  // Week 8: Sep 11 - Sep 17, 2023
  { date: "Sep 17, 2023", transactionCount: 2 },
  { date: "Sep 16, 2023", transactionCount: 3 },
  { date: "Sep 15, 2023", transactionCount: 2 },
  { date: "Sep 14, 2023", transactionCount: 3 },
  { date: "Sep 13, 2023", transactionCount: 2 },
  { date: "Sep 12, 2023", transactionCount: 2 },
  { date: "Sep 11, 2023", transactionCount: 1 },
  
  // Week 9: Sep 04 - Sep 10, 2023
  { date: "Sep 10, 2023", transactionCount: 2 },
  { date: "Sep 09, 2023", transactionCount: 3 },
  { date: "Sep 08, 2023", transactionCount: 2 },
  { date: "Sep 07, 2023", transactionCount: 3 },
  { date: "Sep 06, 2023", transactionCount: 2 },
  { date: "Sep 05, 2023", transactionCount: 2 },
  { date: "Sep 04, 2023", transactionCount: 1 },
  
  // Week 10: Aug 28 - Sep 03, 2023
  { date: "Sep 03, 2023", transactionCount: 2 },
  { date: "Sep 02, 2023", transactionCount: 3 },
  { date: "Sep 01, 2023", transactionCount: 2 },
  { date: "Aug 31, 2023", transactionCount: 3 },
  { date: "Aug 30, 2023", transactionCount: 2 },
  { date: "Aug 29, 2023", transactionCount: 2 },
  { date: "Aug 28, 2023", transactionCount: 1 },
  
  // Week 11: Aug 21 - Aug 27, 2023
  { date: "Aug 27, 2023", transactionCount: 2 },
  { date: "Aug 26, 2023", transactionCount: 3 },
  { date: "Aug 25, 2023", transactionCount: 2 },
  { date: "Aug 24, 2023", transactionCount: 3 },
  { date: "Aug 23, 2023", transactionCount: 2 },
  { date: "Aug 22, 2023", transactionCount: 2 },
  { date: "Aug 21, 2023", transactionCount: 1 },
];

// Generate all detailed transactions
const generateDetailedTransactions = () => {
  const allTransactions = [];
  let currentId = 1;
  
  dailySummaryDates.forEach(day => {
    const dayTransactions = generateTransactionsByDate(day.date, day.transactionCount, currentId);
    allTransactions.push(...dayTransactions);
    currentId += day.transactionCount;
  });
  
  return allTransactions;
};

// Generate transactions first
const detailedTransactions = generateDetailedTransactions();

// Helper function to calculate daily summaries from actual transactions
const calculateDailySummaries = (dates, transactions) => {
  return dates.map(dayInfo => {
    const dayTransactions = transactions.filter(txn => txn.date === dayInfo.date);
    
    const totalEarnings = dayTransactions
      .filter(txn => txn.status === "COMPLETED")
      .reduce((sum, txn) => sum + txn.netEarning, 0);
    
    // ✅ Calculate penalty from rejected transactions
    const penaltyAmount = -dayTransactions
      .filter(txn => txn.status === "REJECTED")
      .reduce((sum, txn) => sum + txn.rejectionPenalty, 0);
    
    const penaltyCount = dayTransactions.filter(txn => txn.status === "REJECTED").length;
    
    return {
      date: dayInfo.date,
      transactionCount: dayInfo.transactionCount,
      totalEarnings: parseFloat(totalEarnings.toFixed(2)),
      penaltyCount,
      penaltyAmount,
      netAmount: parseFloat((totalEarnings + penaltyAmount).toFixed(2)),
    };
  });
};

// Helper function to calculate week totals
const calculateWeekTotals = (dailySummaries) => {
  const totalAmount = dailySummaries.reduce((sum, day) => sum + day.netAmount, 0);
  const transactionCount = dailySummaries.reduce((sum, day) => sum + day.transactionCount, 0);
  return {
    totalAmount: parseFloat(totalAmount.toFixed(2)),
    transactionCount,
  };
};

export const mockTransactionsData = {
  summary: {
    totalEarnings: 28650.0,
    totalPending: 1500.0,
    totalPaid: 25200.0,
    totalPenalties: 200.0,
  },
  weeks: [
    {
      id: 1,
      weekLabel: "Week: Oct 30 - Nov 05, 2024",
      startDate: "2024-10-30",
      endDate: "2024-11-05",
      status: "PENDING",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(0, 7),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(0, 7), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(0, 7), detailedTransactions);
      },
    },
    {
      id: 2,
      weekLabel: "Week: Oct 23 - Oct 29, 2024",
      startDate: "2024-10-23",
      endDate: "2024-10-29",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(7, 14),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(7, 14), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(7, 14), detailedTransactions);
      },
    },
    {
      id: 3,
      weekLabel: "Week: Oct 16 - Oct 22, 2023",
      startDate: "2023-10-16",
      endDate: "2023-10-22",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(14, 21),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(14, 21), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(14, 21), detailedTransactions);
      },
    },
    {
      id: 4,
      weekLabel: "Week: Oct 09 - Oct 15, 2023",
      startDate: "2023-10-09",
      endDate: "2023-10-15",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(21, 28),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(21, 28), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(21, 28), detailedTransactions);
      },
    },
    {
      id: 5,
      weekLabel: "Week: Oct 02 - Oct 08, 2023",
      startDate: "2023-10-02",
      endDate: "2023-10-08",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(28, 35),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(28, 35), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(28, 35), detailedTransactions);
      },
    },
    {
      id: 6,
      weekLabel: "Week: Sep 25 - Oct 01, 2023",
      startDate: "2023-09-25",
      endDate: "2023-10-01",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(35, 42),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(35, 42), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(35, 42), detailedTransactions);
      },
    },
    {
      id: 7,
      weekLabel: "Week: Sep 18 - Sep 24, 2023",
      startDate: "2023-09-18",
      endDate: "2023-09-24",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(42, 49),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(42, 49), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(42, 49), detailedTransactions);
      },
    },
    {
      id: 8,
      weekLabel: "Week: Sep 11 - Sep 17, 2023",
      startDate: "2023-09-11",
      endDate: "2023-09-17",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(49, 56),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(49, 56), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(49, 56), detailedTransactions);
      },
    },
    {
      id: 9,
      weekLabel: "Week: Sep 04 - Sep 10, 2023",
      startDate: "2023-09-04",
      endDate: "2023-09-10",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(56, 63),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(56, 63), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(56, 63), detailedTransactions);
      },
    },
    {
      id: 10,
      weekLabel: "Week: Aug 28 - Sep 03, 2023",
      startDate: "2023-08-28",
      endDate: "2023-09-03",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(63, 70),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(63, 70), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(63, 70), detailedTransactions);
      },
    },
    {
      id: 11,
      weekLabel: "Week: Aug 21 - Aug 27, 2023",
      startDate: "2023-08-21",
      endDate: "2023-08-27",
      status: "PAID",
      get totalAmount() {
        const summaries = calculateDailySummaries(
          dailySummaryDates.slice(70, 77),
          detailedTransactions
        );
        return calculateWeekTotals(summaries).totalAmount;
      },
      get transactionCount() {
        return calculateWeekTotals(
          calculateDailySummaries(dailySummaryDates.slice(70, 77), detailedTransactions)
        ).transactionCount;
      },
      get dailySummaries() {
        return calculateDailySummaries(dailySummaryDates.slice(70, 77), detailedTransactions);
      },
    },
  ],
  detailedTransactions,
};
